import React from "react";

export function CLLoadingIcon() {
  return <img className='fade-in-out' alt='Clazar logo' src='/icon.svg' />;
}
